import QuickModal from '../components/quick/QuickModal';
import TimePresets from '../components/quick/TimePresets';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BsCalendarEvent, BsFlagFill, BsCheckCircle, BsClock, BsGlobe } from 'react-icons/bs';
import { apiFetch, parseJsonSafe } from '../utils/api';

const DashboardPage = () => {
  const token = localStorage.getItem('token');
  const todayStr = () => new Date().toISOString().slice(0, 10);
  const [eventPreview, setEventPreview] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [eventsToday, setEventsToday] = useState([]);
  const [tasksHigh, setTasksHigh] = useState([]);
  const [users, setUsers] = useState([]);
  const [timeModal, setTimeModal] = useState({ open: false, task: null, hours: 1, minutes: 0, comments: '', user_id: null, date: todayStr() });
  const [savingTime, setSavingTime] = useState(false);
  const [expiredDomains, setExpiredDomains] = useState(0);

  const handleUnauthorized = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    window.location.href = '/login';
  };

  const loadEventsToday = async () => {
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const start = new Date();
      start.setHours(0, 0, 0, 0);
      const end = new Date();
      end.setHours(23, 59, 59, 999);
      const qs = new URLSearchParams({ from: start.toISOString(), to: end.toISOString(), mine: 'true' });
      const evRes = await apiFetch(`/api/calendar/events?${qs.toString()}`, { headers });
      const evData = await parseJsonSafe(evRes);
      if (evRes.status === 401) return handleUnauthorized();
      if (evRes.ok && Array.isArray(evData)) {
        setEventsToday(evData.slice(0, 10));
      }
    } catch (err) {
      console.error('Error cargando eventos', err);
    }
  };

  const refreshTasksHigh = async () => {
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const tRes = await apiFetch('/api/tasks?estado=pendiente&page=1&pageSize=50', { headers });
      const tData = await parseJsonSafe(tRes);
      if (tRes.status === 401) return handleUnauthorized();
      if (tRes.ok) {
        const items = Array.isArray(tData) ? tData : tData.items || [];
        const high = items.filter((t) => t.importance === 'alta').slice(0, 5);
        setTasksHigh(high);
      }
    } catch (err) {
      console.error('Error cargando tareas', err);
    }
  };


  const loadExpiredDomains = async () => {
    try {
      const res = await apiFetch('/api/domains/all?pageSize=1', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok) setExpiredDomains(Number(data.expiredTotal || 0));
    } catch (err) {
      console.error('Error cargando dominios caducados', err);
    }
  };

  const loadUsers = async () => {
    try {
      const res = await apiFetch('/api/users', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok && Array.isArray(data)) setUsers(data);
    } catch (err) {
      console.error('Error cargando usuarios', err);
    }
  };

  useEffect(() => {
    apiFetch('/api/dashboard', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(async (res) => {
        const data = await parseJsonSafe(res);
        if (res.status === 401) return handleUnauthorized();
        if (!res.ok) {
          throw new Error(data.message || 'Error cargando dashboard');
        }
        const email = data.user && data.user.email ? data.user.email : '';
        setMessage(email ? `${data.message} (${email})` : data.message || 'OK');
      })
      .catch((err) => setError(err.message));

    loadEventsToday();
    refreshTasksHigh();
    loadUsers();
    loadExpiredDomains();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const markTaskDone = async (task) => {
    try {
      const res = await apiFetch(`/api/tasks/${task.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ estado: 'realizada' })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo actualizar la tarea');
      await refreshTasksHigh();
    } catch (err) {
      setError(err.message);
    }
  };

  const openTimeModalForTask = (task) => {
    setTimeModal({ open: true, task, hours: 1, minutes: 0, comments: '', user_id: task.user_id || null, date: todayStr() });
  };

  const closeTimeModal = () => setTimeModal({ open: false, task: null, hours: 1, minutes: 0, comments: '', user_id: null, date: todayStr() });

  const saveTimeForTask = async () => {
    if (!timeModal.task) return;
    const mins = Number(timeModal.hours) * 60 + Number(timeModal.minutes || 0);
    if (!mins) {
      setError('Tiempo debe ser mayor que 0');
      return;
    }
    setSavingTime(true);
    try {
      const res = await apiFetch(`/api/tasks/${timeModal.task.id}/time`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          minutes: mins,
          comments: timeModal.comments,
          user_id: timeModal.user_id,
          date: timeModal.date || todayStr()
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar el tiempo');
      closeTimeModal();
      await refreshTasksHigh();
    } catch (err) {
      setError(err.message);
    } finally {
      setSavingTime(false);
    }
  };

  const formatTime = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h2 className="mb-0">Dashboard</h2>
          <div className="text-muted">Resumen rápido de lo que requiere atención hoy.</div>
        </div>
      </div>
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      {expiredDomains > 0 && (
        <Link to="/dominios?expired=1" className="text-decoration-none">
          <div className="alert alert-warning d-flex align-items-center gap-2 mt-3 mb-0" role="alert" style={{ cursor: 'pointer' }}>
            <BsGlobe />
            <span><strong>{expiredDomains}</strong> dominio{expiredDomains === 1 ? '' : 's'} caducado{expiredDomains === 1 ? '' : 's'}. Haz clic para revisarlos.</span>
          </div>
        </Link>
      )}

      <div className="row g-3 mt-3">
        <div className="col-12 col-lg-6">
          <div className="card shadow-sm border-0" style={{ background: 'linear-gradient(135deg, #eef2ff, #ffffff)' }}>
            <div className="card-body">
              <div className="d-flex align-items-center mb-3">
                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: 34, height: 34 }}>
                  <BsCalendarEvent />
                </div>
                <div>
                  <div className="text-uppercase text-muted small mb-0">Eventos de hoy</div>
                  <h5 className="mb-0">Agenda</h5>
                </div>
              </div>
              {eventsToday.length ? (
                <ul className="list-unstyled mb-0">
                  {eventsToday.map((ev) => {
                    // El backend devuelve ev.start como string ISO (dateTime) o fecha (all-day).
                    const start = ev.start;
                    const hasTime = typeof start === 'string' && start.includes('T');
                    const time = hasTime ? formatTime(start) : '';
                    return (
                      <li key={ev.id} className="mb-2 d-flex align-items-start">
                        <div className="me-2" style={{ width: 6, height: 32, borderRadius: 3, background: '#4f46e5' }}></div>
                        <div>
                          <button type="button" className="btn btn-link p-0 fw-bold text-start" onClick={() => setEventPreview(ev)}>{ev.summary || 'Evento'}</button>
                          {/^https:\/\//i.test(ev.hangoutLink || '') && <a className="btn btn-sm btn-outline-primary ms-2" href={ev.hangoutLink} target="_blank" rel="noreferrer">Entrar en Meet</a>}
                          <div className="text-muted small">{time ? `${time}` : 'Todo el día'}</div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <p className="text-muted mb-0">Sin eventos para hoy.</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="card shadow-sm border-0" style={{ background: 'linear-gradient(135deg, #fff7ed, #ffffff)' }}>
            <div className="card-body">
              <div className="d-flex align-items-center mb-3">
                <div className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: 34, height: 34 }}>
                  <BsFlagFill />
                </div>
                <div>
                  <div className="text-uppercase text-muted small mb-0">Prioridad alta</div>
                  <h5 className="mb-0">Tareas</h5>
                </div>
                {tasksHigh.length ? <span className="badge bg-danger ms-auto">{tasksHigh.length}</span> : null}
              </div>
              {tasksHigh.length ? (
                <ul className="list-unstyled mb-0">
                  {tasksHigh.map((t) => (
                    <li key={t.id} className="mb-2 p-2 rounded border d-flex justify-content-between align-items-center">
                      <div>
                        <Link className="fw-semibold" to={`/tareas?taskId=${t.id}`}>{t.titulo}</Link>
                        <div className="text-muted small">
                          {t.client_name ? t.client_name : 'Sin cliente'}
                          {t.estado ? ` · ${t.estado}` : ''}
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <span className="badge bg-danger">Alta</span>
                        <button className="btn btn-sm btn-outline-success" title="Marcar como realizada" onClick={() => markTaskDone(t)}>
                          <BsCheckCircle />
                        </button>
                        <button className="btn btn-sm btn-outline-secondary" title="Añadir tiempo dedicado" onClick={() => openTimeModalForTask(t)}>
                          <BsClock />
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted mb-0">Sin tareas de alta prioridad.</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {eventPreview && <QuickModal title={eventPreview.summary || 'Evento'} onClose={() => setEventPreview(null)}>
        <p>{eventPreview.start ? new Date(eventPreview.start).toLocaleString('es-ES') : 'Sin fecha'}</p>
        <p style={{ whiteSpace: 'pre-wrap' }}>{eventPreview.description || 'Sin descripción'}</p>
        {/^https:\/\//i.test(eventPreview.hangoutLink || '') && <a className="btn btn-primary me-2" href={eventPreview.hangoutLink} target="_blank" rel="noreferrer">Entrar en Meet</a>}
        <Link className="btn btn-outline-secondary" to={`/agenda?eventId=${encodeURIComponent(eventPreview.id)}&date=${encodeURIComponent(String(eventPreview.start || '').slice(0, 10))}`}>Abrir en agenda</Link>
      </QuickModal>}
      {timeModal.open && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.4)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Tiempo dedicado - {timeModal.task?.titulo}</h5>
                <button className="btn-close" onClick={closeTimeModal}></button>
              </div>
              <div className="modal-body">
                <TimePresets onChange={(hours, minutes) => setTimeModal((p) => ({ ...p, hours, minutes }))} />
                <div className="row g-2 mb-2">
                  <div className="col-12">
                    <label className="form-label">Fecha</label>
                    <input type="date" className="form-control" value={timeModal.date} onChange={(e) => setTimeModal((p) => ({ ...p, date: e.target.value }))} />
                  </div>
                  <div className="col-6">
                    <label className="form-label">Horas</label>
                    <input type="number" min="0" className="form-control" value={timeModal.hours} onChange={(e) => setTimeModal((p) => ({ ...p, hours: Number(e.target.value) }))} />
                  </div>
                  <div className="col-6">
                    <label className="form-label">Minutos</label>
                    <input type="number" min="0" max="59" className="form-control" value={timeModal.minutes} onChange={(e) => setTimeModal((p) => ({ ...p, minutes: Number(e.target.value) }))} />
                  </div>
                </div>
                <div className="mb-2">
                  <label className="form-label">Comentarios</label>
                  <textarea className="form-control" rows="3" value={timeModal.comments} onChange={(e) => setTimeModal((p) => ({ ...p, comments: e.target.value }))} />
                </div>
                <div className="mb-2">
                  <label className="form-label">Usuario</label>
                  <select className="form-select" value={timeModal.user_id || ''} onChange={(e) => setTimeModal((p) => ({ ...p, user_id: e.target.value ? Number(e.target.value) : null }))}>
                    <option value="">Sin usuario</option>
                    {users.map((u) => (
                      <option key={u.id} value={u.id}>{u.name || u.email}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={closeTimeModal}>Cerrar</button>
                <button className="btn btn-primary" disabled={savingTime} onClick={saveTimeForTask}>{savingTime ? 'Guardando...' : 'Guardar'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default DashboardPage;
